<!--ptw总包与分包分类-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Permit-to-Work (PTW) Type
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;display: inline-block">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="ptwclassifyDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
    <div class="daily_ptw_detail" v-show="showflag" id="daily_ptw_detail">
      <div class="close_img_gentry" @click="detailClose"></div>
      <p style="margin-top: 20px; margin-left: 20px; text-align: left">{{ detailTitle }}</p>
      <div class="ptwDiv1" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "ptwclassifys",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      myChart1: null,
      name: "ptwclassifys",
      dataNotNull: true,
      default_tag: "Daily",
      typeConList: [],
      detailTitle: '',
      legends: [],
      multi_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        {label: "Acc.", value: "2"},
      ],
      showflag: false,
    }
  },
  methods: {
    switch_tag(label) {
      this.getData(label)
    },
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    init_chart() {
      var that = this
      this.myChart = echarts.init(document.querySelector('.ptwclassifyDiv .container1'))
      this.myChart.setOption({
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}: {c} ({d}%)",
          textStyle: {
            fontSize: 40
          }
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          left: '48%',
          top: '0',
          itemGap: 24,
          itemHeight: '28',
          itemWidth: 80,
          textStyle: {
            color: '#FFF',
            fontSize: '32'
          },
          data: []
        },
        series: [{
          name: 'PTW',
          data: [],
          type: 'pie',
          hoverOffset: 5,
          radius: ['45%', '65%'],
          center: ['25%', '50%'],
          label: {
            normal: {
              show: true,
              position: 'inside',
              formatter: '{c}',
              textStyle: {
                fontSize: '36',
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '48',
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },

          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              }
            },
            //鼠标悬停时：
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              borderWidth: 1
            }
          }
        }],
      })

      this.myChart.showLoading({
        text: '',
        color: '#66CCFF',
        maskColor: 'rgba(255, 255, 255, 0)',
      });
      this.myChart.on('legendselectchanged', function (param) {
        that.showPtw(param.name)
      });
    },
    formatWidth(str, width) {
      str += ''
      if (str.length < width)
        return this.formatWidth('0' + str, width)
      else
        return str
    },
    detailClose() {
      this.showflag = false
    },
    analysisResult(result) {
      var ptwclassifys = []
      var gap = 24
      var legends = []
      var result1 = []
      var con_tag = []
      var con_list = []
      this.typeConList = []
      this.legends = []
      for (var i in result) {
        let tindex = legends.indexOf(result[i].type)
        if (tindex < 0) {
          legends.push(result[i].type)
          let last_index = this.typeConList.length - 1
          if (last_index >= 0) {
            this.typeConList[last_index].con_tag = con_tag
            this.typeConList[last_index].con_list = con_list
          }
          this.typeConList.push({
            con_tag: [],
            con_list: []
          })
          con_tag = []
          con_list = []
          result1.push({type: result[i].type, count: parseInt(result[i].count)})
        } else {
          result1[tindex].count += parseInt(result[i].count)
        }
        let cindex = con_tag.indexOf(result[i].con_name.substring(0, 13) + '\n' + result[i].con_name.substring(13, result[i].con_name.length))
        if (cindex < 0) {
          con_tag.push(result[i].con_name.substring(0, 13) + '\n' + result[i].con_name.substring(13, result[i].con_name.length))
          con_list.push(parseInt(result[i].count))
        } else {
          con_list[cindex] += parseInt(result[i].count)
        }
      }
      let last_index = this.typeConList.length - 1
      if (last_index >= 0) {
        this.typeConList[last_index].con_tag = con_tag
        this.typeConList[last_index].con_list = con_list
      }
      this.typeConList.sort(function (a, b) {
        return eval(b.con_list.join("+")) - eval(a.con_list.join("+"))
        // return b.count - a.count
      })
      legends = []
      result1.sort(function (a, b) {
        return parseInt(b.count) - parseInt(a.count)
      })
      if (result1.length > 10) {
        gap = 12
        //按照count降序
        //将result分为两部分，第一部分9个元素，第二部分为剩下的元素作为Others
        var shows = result1.slice(0, 9)
        var others = result1.slice(9)
        var other = 0

        for (var i in shows) {
          var type = shows[i].type
          //如果第一部分本身包含了'other'或类似的type，则将其与第二部分的第一个进行交换，其本身被添加至第二部分的尾部，other作为交换数目的标识
          if (type.toLowerCase() == 'other') {
            other += parseInt('1')
            others.push(shows[i])
          } else {
            legends.push(type)
            ptwclassifys.push({name: type, value: shows[i].count})
          }
        }
        //从第二部分取出other个元素，完成交换
        var replace = others.splice(0, other)
        for (var i in replace) {
          legends.push(replace[i].type)
          ptwclassifys.push({name: replace[i].type, value: replace[i].count})
        }
        //第二部分作为一个'Others'type整体，加入到chart中
        var otherCount = 0
        for (var i in others) {
          otherCount += parseInt(others[i].count)
        }
        legends.push('Others')
        ptwclassifys.push({name: 'Others', value: otherCount})
      } else {
        for (var i in result1) {
          legends.push(result1[i].type)
          ptwclassifys.push({name: result1[i].type, value: result1[i].count})
        }
        if (result1.length > 6) {
          gap -= (result1.length - 6) * 3
        }
      }
      this.legends = legends
      return {legends: legends, ptwclassifys: ptwclassifys, gap: gap}
    },
    getData(period) {
      var that = this
      let day = new Date();
      day.setTime(day.getTime());
      let today = day.getFullYear() + "-" + this.formatWidth((day.getMonth() + 1), 2) + "-" + this.formatWidth(day.getDate(), 2)
      let postData = {
        project_id: this.my_project_id,
        period: period,
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjPTWTypeCon", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          that.dataNotNull = true
          that.$nextTick().then(() => {
            that.init_chart()
            that.myChart.hideLoading()
            // that.myChart.hideLoading()
            var result = resp.data.result;
            var data = this.analysisResult(result)
            this.myChart.setOption({
              legend: {
                data: data.legends,
                itemGap: data.gap,
                top: data.gap == 6 ? '15' : 'middle'
              },
              series: [{
                data: data.ptwclassifys
              }]
            })
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    showPtw(name) {
      let that = this
      var tags = []
      var datas = []
      let index = that.legends.indexOf(name)

      tags = that.typeConList[index].con_tag
      datas = that.typeConList[index].con_list
      that.detailTitle = that.workers + "  Workers"
      that.detailTitle = that.legends[index] + " Contractor State"

      that.showflag = true
      this.$nextTick(() => {
        this.myChart1 = echarts.init(document.querySelector('.ptwDiv1 .container1'))
        this.myChart1.setOption({
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },
            formatter: function (params) {
              return params[0].value
            },
            textStyle: {
              fontSize: '40'
            }
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              yAxisIndex: [0],
              left: '95%',
              startValue: 0, // 从头开始。
              endValue: 4,  // 一次性展示5个。
              showDetail: false,
              zoomLock: true,
              width: '3%',
              orient: "vertical"
            }
          ],
          grid: {
            left: 220
          },
          xAxis: {
            type: 'value',
            show: false,
            axisLabel: {
              formatter: '{value}'
            }
          },
          yAxis: {
            type: 'category',
            inverse: true,
            data: tags,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#6CF'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 15,
              show: true,
              textStyle: {
                color: '#333',
                fontSize: 24
              },
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              name: '申请',
              type: 'bar',
              barWidth: '60%',
              data: datas,
              label: {
                normal: {
                  show: true,
                  color: '#6cf',
                  position: 'right',
                  fontSize: '25',
                  formatter: function (params) {
                    return params.value
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: function (params) {
                    return that.color[params.dataIndex]
                  },
                }
              },
            }
          ]
        })
      })
    },
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
    if (this.myChart1) {
      this.myChart1.clear()
    }
  },

  mounted() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.getData('0')
  }
}
</script>


<style lang="stylus" rel="stylesheet/stylus">
.daily_ptw_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}
</style>




// WEBPACK FOOTER //
// src/components/safety_manage/ptwclassify.vue